module.exports = __webpack_public_path__ + "static/media/ic_class_back.d65e89a5.svg";